module.exports = __webpack_public_path__ + "static/media/airplane.20f19f9e.svg";